import t_15_2500 from './KZ.T.15.2500.svg'
import t_15_2500_b from './KZ.T.15.2500 black.svg'

export default [
  t_15_2500,
  t_15_2500_b,
]
